/** Days left in a trial, rounded UP: a 14-day trial shows 14 on day 0, 0 once ended. */
export function trialDaysLeft(endDate: string | Date | null | undefined, now: Date = new Date()): number {
  if (!endDate) return 0;
  const ms = new Date(endDate).getTime() - now.getTime();
  return ms > 0 ? Math.ceil(ms / 86_400_000) : 0;
}

/** "Il vous reste 14 jours d'essai gratuit" (explicit spaces, singular/plural). */
export function trialRemainingLabel(days: number): string {
  return `Il vous reste ${days} jour${days > 1 ? "s" : ""} d'essai gratuit`;
}
